// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__HlqKG","text":"Faq_text__7V0Hg","question":"Faq_question__tK+la","answer":"Faq_answer__Nxpe7","contact":"Faq_contact__l4cqt"};